






















import { Vue, Component, Prop } from 'vue-property-decorator'

import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/grid.min.css'

@Component
export default class Module extends Vue {
  @Prop(Boolean) readonly admin!: boolean
  @Prop(String) readonly usage!: string
  @Prop(String) readonly name!: string
  @Prop(Array) readonly alts!: string[]
  @Prop(String) readonly desc!: string
  @Prop(Boolean) readonly sfw!: boolean
  @Prop(Boolean) readonly showNSFW!: boolean
  @Prop(Boolean) readonly showAdmin!: boolean
}
